export default __webpack_public_path__ + "ea2e3bb04dfe5fe049b0a13125e52aef.webp";